import _flow from "lodash/flow";
import _set from "lodash/set";
import _get from "lodash/get";
import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { readProfile, readYodleeProfile } from "../actions";
import { getProviderAccountsNeedingMfa } from "../selectors/yodlee";
import { fetchFinancialData, transformFinancialDataProfileToLegacyDataShape } from "../utils/financial-data";

var overrideFinancialAccountActions = function overrideFinancialAccountActions(action, dispatch, currentState) {
  var actionName = action.actionName;
  var updatedAction = action; // `readProfile` actions that query for a Yodlee profile must be intercepted and replaced with a call
  // to retrieve the FDP financial data unless the user is linking MFA, which includes data like the mfa_form
  // that must come from identity.

  if (_get(updatedAction, 'meta.profileType') === NwApiSDK.IDENTITY_PROFILES.YODLEE_PROFILE && getProviderAccountsNeedingMfa(currentState.identity).length === 0) {
    if (actionName === readProfile.NAME) {
      updatedAction.makeRequest = function (_state, _ref) {
        var apolloClient = _ref.apolloClient;
        return fetchFinancialData(apolloClient);
      };
    } else if (action.type === readProfile.success.getType()) {
      var financialDataPath = 'payload.data'; // After retrieving the financial platform data, we transform it to the legacy data shape

      var financialData = _get(updatedAction, financialDataPath);

      _set(updatedAction, financialDataPath, transformFinancialDataProfileToLegacyDataShape(financialData)); // If after fetching the user's financial data via FDP they now have an institution requiring MFA, we need to double
      // fetch and switch to fetching from identity since FDP does not serve the MFA information we need.
      // FIXME: this condition directly contradicts with line 63 and so will never be met


      if (getProviderAccountsNeedingMfa(currentState.identity).length > 0) {
        dispatch(readYodleeProfile());
      }
    }
  }

  return updatedAction;
};
/**
 * FinancialDataMiddleware - A middleware for intercepting legacy Yodlee actions and converting their API calls and responses
 * to FDP calls using the new FDP platform and graphql architecture. This is a first-pass solution that will be removed once the redux clients
 * are migrated to use the FDP queries directly. For backwards-compatibility, this short-term solution exists.
 */


var middleware = function middleware(_ref2) {
  var getState = _ref2.getState,
      dispatch = _ref2.dispatch;
  return function (next) {
    return function (action) {
      var currentState = getState();
      return _flow([overrideFinancialAccountActions, next])(action, dispatch, currentState);
    };
  };
};

export default middleware;